import { FAIcon } from '~/components/utils/FAIcons';

interface SearchInputProps {
	value?: string;
	placeholder?: string;
	defaultValue?: string;
	searchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
	fullWidth?: boolean;
	dirtyWarning?: boolean;
	zIndexEnabled?: boolean;
}

export const SearchInput = ({
	placeholder,
	defaultValue,
	searchChange,
	onFocus,
	fullWidth,
	value,
	dirtyWarning,
	zIndexEnabled = true,
}: SearchInputProps) => {
	return (
		<div className={`relative rounded-md shadow-xs ${zIndexEnabled ? 'z-10' : ''} group ${fullWidth ? 'w-full' : ''}`}>
			<input
				type="text"
				name="search"
				id="search"
				className={`block w-full rounded-md border-gray-300 pr-10 ${
					dirtyWarning ? 'focus:border-yellow-600 focus:ring-yellow-600' : 'focus:border-blue-500 focus:ring-blue-500'
				} sm:text-sm`}
				defaultValue={defaultValue}
				value={value}
				placeholder={placeholder || 'Search'}
				onChange={searchChange}
				autoComplete="off"
				onFocus={onFocus}
			/>
			<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
				<FAIcon icon="magnifying-glass" className={`text-gray-400 ${dirtyWarning ? 'focus:text-yellow-600' : ''}`} />
			</div>
		</div>
	);
};
